import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PersonalInjuryIcon(props: IconProps) {
    return <Icon {...props} iconKey={"personal_injury"}/>
}
